import { FC, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import find from 'lodash/find';
import useForm from 'antd/lib/form/hooks/useForm';

import { PROCESSING_TIME_DATA } from 'components/Settings/dataConstants';
import WithSettingsForm from 'components/Settings/hocs/WithSettingsForm';
import ReturnsPolicy from 'components/Settings/PoliciesTab/ReturnsPolicy';
import ShippingPolicy from 'components/Settings/PoliciesTab/ShippingPolicy';
import SettingsSkeleton from 'components/Skeletons/Settings/SettingsSkeleton';
import { selectPolicySettings } from 'store/selectors/settingsSelectors';
import { getSettingsByKeyAction, updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { useTypedSelector } from 'hooks/useTypedSelector';
import sendGTM from 'utils/sendGTM';
import { SettingsTabPaths } from 'components/Settings/constants';
import { GTM_UPDATE_SETTINGS } from 'utils/constants/gtmConstants';
import { EPoliciesFields } from 'types/settings/enums';

const PoliciesTab: FC = () => {
  const dispatch = useDispatch();
  const { isLoading, isUpdated, ...policySettings } = useTypedSelector(selectPolicySettings);
  const [isShippingError, setIsShippingError] = useState(false);
  const [form] = useForm();

  const handleSubmit = async() => {
    const values = form.getFieldsValue();

    await dispatch(updateSettingsByKeyAction(values, ESettingsKey.PolicySettings));
    if (form.isFieldTouched(EPoliciesFields.ProcessingTimeId)) {
      const processingTime = find(PROCESSING_TIME_DATA, { id: form.getFieldValue(EPoliciesFields.ProcessingTimeId) });

      sendGTM({
        ...GTM_UPDATE_SETTINGS,
        ...(form.isFieldTouched(EPoliciesFields.ProcessingTimeId)
          && { supplier_proccessing_time: `${processingTime?.dayFrom}-${processingTime?.dayTo}` }),
      });
    }
  };

  useEffect(() => {
    !isUpdated && dispatch(getSettingsByKeyAction(ESettingsKey.PolicySettings));
  }, []);

  return (
    isLoading
      ? <SettingsSkeleton />
      : <>
        <WithSettingsForm
          form={form}
          initialValues={policySettings}
          rootPath={SettingsTabPaths.Policies}
          onSubmit={handleSubmit}
        >
          <ShippingPolicy isShippingError={isShippingError} setIsShippingError={setIsShippingError} />
          <ReturnsPolicy />
        </WithSettingsForm>
      </>
  );
};

export default memo(PoliciesTab);
